"use strict";
exports.__esModule = true;
exports.InvalidValueError = exports.UnsupportedPropertyError = void 0;
exports.UnsupportedPropertyError = function (propertyPath) {
    return Error("Unsupported property \"" + propertyPath + "\"");
};
exports.InvalidValueError = function (propertyPath, expectedType, actualValue) { return Error(propertyPath + " must be " + expectedType + ", got \"" + actualValue + "\""); };
//# sourceMappingURL=errors.js.map